import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, getUser } from '../services/authApi';
import { useRestaurant } from '../contexts/RestaurantContext';

const ROLE_DEFAULT_PATH = {
  cocina: '/kitchen/1',
  mostrador: '/',
  soporte: '/support',
  admin: '/',
};

export default function Login() {
  const navigate = useNavigate();
  const { reload, domainBranding } = useRestaurant();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const user = getUser();
    if (user) navigate(ROLE_DEFAULT_PATH[user.role] || '/', { replace: true });
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await login(username, password);
      await reload();
      navigate(ROLE_DEFAULT_PATH[data.role] || '/', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '12px',
    marginBottom: '12px',
    borderRadius: '8px',
    border: '1px solid #333',
    background: '#2a2a2a',
    color: '#fff',
    fontSize: '15px',
    boxSizing: 'border-box',
    outline: 'none',
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#111', fontFamily: 'Arial' }}>
      <div style={{ background: '#1a1a1a', padding: '40px', borderRadius: '12px', width: '320px', boxShadow: '0 8px 32px rgba(0,0,0,0.5)' }}>
        <h2 style={{ color: '#fff', textAlign: 'center', marginBottom: '8px', fontSize: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          {domainBranding?.logo_url ? (
            <img src={domainBranding.logo_url} alt={domainBranding.name} style={{ height: '32px', maxWidth: '160px', objectFit: 'contain' }} />
          ) : (
            '🍕'
          )}
          {domainBranding?.name || 'Casa Pizza'}
        </h2>
        <p style={{ color: '#888', textAlign: 'center', marginBottom: '28px', fontSize: '14px' }}>Inicia sesión para continuar</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Usuario"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoFocus
            style={inputStyle}
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ ...inputStyle, marginBottom: '16px' }}
          />
          {error && (
            <div style={{ color: '#ef4444', fontSize: '13px', marginBottom: '12px', textAlign: 'center' }}>
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            style={{ width: '100%', padding: '13px', background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}
          >
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
}
